<div class="calendar">
  <mat-calendar (selectedChange)="onSelectedDatesChange($event)" [selected]="selectedDateRange"> </mat-calendar>
  <button class="calendar-button" (click)="resetDates(); dialogRef.close()">Réinitialiser</button>
</div>
